import { useConfig } from '../../../hooks/use-config'
import { findConfigValue } from '../../../lib/config'

/**
 * Returns an in-app messages poll interval in milliseconds.
 * @param {string} configKey - app config key holding the interval in seconds,
 *   e.g. IN_APP_MESSAGES.REAL_TIME_POLL_INTERVAL or IN_APP_MESSAGES.HUB_POLL_INTERVAL
 * Returns 0 (no scheduled polling) when the value is 0, missing (including
 * before app config has loaded), negative or not a number.
 */
export const usePollInterval = configKey => {
  const { appConfig } = useConfig()
  const seconds = Number(findConfigValue(configKey, appConfig))
  return seconds > 0 ? seconds * 1000 : 0
}
